// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2k_Tv","label":"CategoryService_label__3bfMq","location":"CategoryService_location__28apk"};